import { Button, FormControl, FormHelperText } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import en from '../../../../lang/en-us';
import TextInput from '../../../../lib/TextField';
import { BANK_DETAILS_WITH_NO_IFSC } from '../../portfolios/utils';
import {
    BANK_ACCOUNT_DETAILS,
    getBankAddress,
    ifscRegex,
    OTP_ACTIONS,
} from '../../../../utils/constants';
import { connect } from 'react-redux';
import { RootStateType } from '../../../../redux-store/reducers';
import { sendPhoneOTP, fetchIFSCDetails } from '../../../../redux-store/actions/nct';
import { IfscModal } from '../../../../lib/NoteModals/ifscModal';
import { ValidationUI } from '../MinorStatus/minor-status-edit-bank';
import { ActionHeader, FaqLink } from '..';
const { dashboard, common } = en;

const initMessage: { error: boolean; message: string } = { error: false, message: '' };

function UpdateIFSCDetails(props: any) {
    const { targetFunds = [] } = props.location.state || {};
    const [ifscError, setIFSCerror] = useState<{ error: boolean; message: string }>(initMessage);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [bankDetails, setBankDetails] = useState<any>({
        bankName: '',
        branch: '',
        city: '',
    });
    const [showLoader, setLoader] = useState<boolean>(false);
    const [ifscValidation, setValidation] = useState<boolean>(false);
    const notInitialRender = useRef<boolean>(false);

    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
        }
    }, []);

    const [bankData, setBankData] = useState<BANK_DETAILS_WITH_NO_IFSC>(targetFunds[0]);

    useEffect(() => {
        const { ifsc = '' } = bankData;
        setLoader(false);
        if (notInitialRender.current) {
            if (ifsc.length === 11) {
                document.getElementById('bank_ifsc')?.blur();
                _getBankDetailsFromIFSC();
            } else {
                setBankData({
                    ...bankData,
                    name: '',
                    branch: '',
                    city: '',
                });
            }
        } else {
            notInitialRender.current = true;
        }
    }, [bankData.ifsc]);

    const handleChange = (e: any) => {
        setIFSCerror({ error: false, message: '' });
        e.target.value.length < 12
            ? setBankData({
                ...bankData,
                ifsc: e.target.value,
            })
            : null;
    };

    const handleSubmit = async () => {
        if (!!bankData.ifsc) {
            if (bankData.ifsc.match(ifscRegex)) {
                try {
                    const { pan, pekrn, mobile } = props;
                    let res = await props.sendPhoneOTP({
                        mobile,
                        pan,
                        pekrn,
                        action: OTP_ACTIONS.changeifsc,
                    });
                    let data = targetFunds.map(
                        (_ele: BANK_DETAILS_WITH_NO_IFSC, index: number) => ({
                            folio: _ele.id,
                            amc: _ele.amc,
                            bankDetails: {
                                accountNo: _ele.accountNo,
                                accountType: _ele.accountType,
                                name: bankDetails.bankName,
                                newIfsc: bankData.ifsc.toUpperCase(),
                                branch: bankDetails.branch,
                                city: bankDetails.city,
                            },
                        }),
                    );
                    let payload = {
                        ...(res || {}).body,
                        mobile,
                        pan,
                        pekrn,
                        data,
                    };

                    props.history.replace('update-ifsc-otp', { ...payload });
                } catch (err: any) {
                    alert(err.message);
                }
            } else {
                setIFSCerror({ error: true, message: common.errors.bankErrors.ifsc.regex });
            }
        } else {
            setIFSCerror({ error: true, message: common.errors.bankErrors.ifsc.required });
        }
    };

    const _getBankDetailsFromIFSC = async () => {
        if (!!bankData.ifsc) {
            if (bankData.ifsc.match(ifscRegex)) {
                setValidation(true);
                setLoader(true);
                const { pan, pekrn, mobile, reqId } = props;
                try {
                    let response: any = await props.fetchIFSCDetails({
                        pan,
                        pekrn,
                        mobile,
                        reqId,
                        ifscCode: bankData.ifsc,
                    });
                    const { errors = [], data = [] } = (response || {}).body;
                    if (errors.length) {
                        const [firstError] = errors;
                        throw Error(firstError?.message);
                    }
                    const [details] = data;
                    const { BankAdd1 = '', BankAdd2 = '', BankAdd3 = '' } = details;
                    setBankDetails({
                        bankName: details.BankName,
                        branch: getBankAddress(BankAdd1, BankAdd2, BankAdd3),
                        city: details.BankCity,
                    });
                    setValidation(false);
                    setShowModal(true);
                } catch (e: any) {
                    setLoader(false);
                    setValidation(false);
                    setIFSCerror({ error: true, message: e.message });
                }
            } else {
                setLoader(false);
                setValidation(false);
                setIFSCerror({ error: true, message: common.errors.bankErrors.ifsc.regex });
            }
        }
    };

    const _handleModalClose = () => {
        setBankDetails({
            bankName: '',
            branch: '',
            city: '',
        });
        setBankData({
            ...bankData,
            ifsc: '',
        });
        setShowModal(false);
    };

    const _handleProceed = () => {
        const { bankName, branch, city } = bankDetails;
        setBankData({
            ...bankData,
            name: bankName,
            branch,
            city,
        });
        setShowModal(false);
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.UpdateIFSC.UpdateIFSCHeading} />
            <div className="curved-bg-content update-pan-selected-content">
                <div className="curved-bg-content-inner">
                    <div className="add-new-bankAccount update-ifsc-details">
                        <h4>{dashboard.UpdateIFSC.Details.heading}</h4>
                        <p>{dashboard.UpdateIFSC.Details.info}</p>
                        <div className="new-bank-fields">
                            <TextInput
                                variant="outlined"
                                label={dashboard.UpdateIFSC.Details.fields.accountNumber}
                                value={bankData?.accountNo}
                                disabled
                            />
                            <FormControl>
                                <TextInput
                                    variant="outlined"
                                    label={dashboard.UpdateIFSC.Details.fields.ifsc}
                                    value={bankData?.ifsc.toUpperCase()}
                                    onChange={handleChange}
                                    error={ifscError.error}
                                    helperText={ifscError.message}
                                    id={'bank_ifsc'}
                                // onBlur={() => validateIfscWithRegex(bankData?.ifsc)}
                                />
                                {showLoader && (
                                    <FormHelperText>
                                        <ValidationUI
                                            isValidating={ifscValidation}
                                            onValidationText={common.validatingIFSC}
                                            successfulValidationText={common.IFSCValidated}
                                        />
                                    </FormHelperText>
                                )}
                            </FormControl>
                            <TextInput
                                variant="outlined"
                                label={dashboard.UpdateIFSC.Details.fields.bankName}
                                value={bankData?.name}
                                disabled
                                title={bankData?.name}
                            />
                            <TextInput
                                variant="outlined"
                                label={dashboard.UpdateIFSC.Details.fields.accountType}
                                value={bankData?.accountType}
                                disabled
                            />
                            <TextInput
                                variant="outlined"
                                label={dashboard.UpdateIFSC.Details.fields.branch}
                                value={bankData?.branch}
                                disabled
                                title={bankData?.branch}
                            />
                            <TextInput
                                variant="outlined"
                                label={dashboard.UpdateIFSC.Details.fields.city}
                                value={bankData?.city}
                                disabled
                                title={bankData?.city}
                            />
                        </div>
                        <FaqLink section={BANK_ACCOUNT_DETAILS} history={props.history} />
                        <Button
                            onClick={handleSubmit}
                            className="customBtn"
                            disabled={!bankData?.ifsc || ifscError.error || ifscValidation}
                        >
                            {dashboard.UpdateIFSC.Details.submit}
                        </Button>
                        <IfscModal
                            extraClass="ifsc-modal"
                            showModal={showModal}
                            heading={dashboard.UpdateIFSC.noteModals.pleaseConfirm}
                            info1={'Bank Name'}
                            info2={'IFSC Code'}
                            info3={'City'}
                            info4={'Branch'}
                            content1={bankDetails.bankName}
                            content2={bankData.ifsc}
                            content3={bankDetails.city}
                            content4={bankDetails.branch}
                            proceedBtn={'Okay'}
                            onProceed={_handleProceed}
                            cancelBtn={'Cancel'}
                            onCancel={_handleModalClose}
                        />
                    </div>
                </div>
            </div>
            {/* <NoteModals
                showModal={show}
                heading={dashboard.UpdateIFSC.noteModals.heading}
                info={dashboard.UpdateIFSC.noteModals.info}
                proceedBtn={dashboard.UpdateIFSC.noteModals.proceedText}
                cancelBtn={dashboard.UpdateIFSC.noteModals.cancelText}
            /> */}
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendPhoneOTP,
    fetchIFSCDetails,
})(UpdateIFSCDetails);
